import { jsx } from "panel";
import { MultiMetricChartEl } from "common/charts/visualization/multi-metric";
import { NoDataHero } from "common/widgets/warning-hero/presets";
import { WarningHeroReportName } from "common/widgets/warning-hero/constants";
export function template() {
  var _a;
  if (!this.hasResults()) {
    return /* @__PURE__ */ jsx("div", {
      sel: ".metric-chart"
    }, /* @__PURE__ */ jsx(NoDataHero, {
      reportName: WarningHeroReportName.Retention
    }));
  }
  return /* @__PURE__ */ jsx("div", {
    sel: ".root"
  }, /* @__PURE__ */ jsx(MultiMetricChartEl, {
    sel: ".metric-chart",
    attrs: { metrics: this.getMetricAttrs(), "lift-type": (_a = this.bookmarkParams.lift_comparison) == null ? void 0 : _a.type },
    props: { metricFormatter: this.getMetricFormatter() }
  }));
}
